import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { ISubPartyV1 } from "src/domain/entities"
import { subPartyDeleteService } from "src/domain/services/subParty/subPartyDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	subParty: ISubPartyV1
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const SubPartyDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	subParty,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleSubPartyDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await subPartyDeleteService({ id: subParty.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [subParty, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Sub-Party: ${subParty.name}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleSubPartyDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
